export default __webpack_public_path__ + "static/media/FSK_Dinner_Menu.7ebded4c.pdf";